import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from './config.service';

export interface SystemNotificationAdmin {
  notificationID: number;
  title: string;
  message: string;
  type: string; // 'info', 'success', 'warning', 'danger'
  priority: number;
  startDate: Date;
  endDate?: Date;
  isActive: boolean;
  createdDate: Date;
  createdBy?: string;
  modifiedDate?: Date;
  modifiedBy?: string;
  clientCount?: number;
  displayType?: 'alert' | 'modal';
  imageUrl?: string;
  ctaText?: string;
  ctaLink?: string;
  targetAudience?: string;
}

export interface SystemNotificationWithClients {
  notification: SystemNotificationAdmin;
  assignedClients: string[];
  isGlobal: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class SystemNotificationAdminService {
  private get apiUrl(): string {
    return `${this.configService.get('apiBaseUrl')}/SystemNotificationAdmin`;
  }

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) { }

  getAllNotifications(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}`).pipe(
      map((response: any) => response)
    );
  }

  getNotificationById(notificationId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${notificationId}`).pipe(
      map((response: any) => response)
    );
  }

  getNotificationWithClients(notificationId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${notificationId}/WithClients`).pipe(
      map((response: any) => response)
    );
  }

  getActiveNotifications(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/Active`).pipe(
      map((response: any) => response)
    );
  }

  createNotification(notification: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}`, notification).pipe(
      map((response: any) => response)
    );
  }

  updateNotification(notificationId: number, notification: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${notificationId}`, notification).pipe(
      map((response: any) => response)
    );
  }

  deleteNotification(notificationId: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${notificationId}`).pipe(
      map((response: any) => response)
    );
  }

  updateNotificationClients(notificationId: number, clientDBNames: string[]): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${notificationId}/Clients`, clientDBNames).pipe(
      map((response: any) => response)
    );
  }
}
